module.exports = __webpack_public_path__ + "media/images/emoticons/free-dc8c6821f4c4b20ad6ef578645374733.gif";